import { ROLES_ACCESS } from "@/helpers/superAdminPermissionConstant";

export default [
  {
    path: "/super-admin/roles",
    name: "super-admin-roles",
    component: () => import("@/views/super-admin/roles/RolesView.vue"),
    meta: {
      gate: ROLES_ACCESS,
      requiresSuperAdmin: true,
      pageTitle: "Roles",
      layout: "super-admin",
      breadcrumb: [
        {
          text: "Roles",
          active: true,
          to: "",
        },
      ],
    },
  },
  {
    path: "/super-admin/roles/:id",
    name: "super-admin-roles-permissions",
    component: () => import("@/views/super-admin/roles/RolePermissionsView.vue"),
    meta: {
      gate: ROLES_ACCESS,
      requiresAuth: true,
      pageTitle: "Permissions",
      homePatch: "/super-admin/dashboard",
      layout: "super-admin",
      breadcrumb: [
        {
          text: "Roles",
          active: false,
          to: "/super-admin/roles",
        },
        {
          text: "Permissions",
          active: true,
          to: "",
        },
      ],
    },
  },
];
